
// import React, { useState } from 'react';
// import Plot from 'react-plotly.js';
// import { getCrossSellRecommendations } from '../api';
// import './CrossSellOpportunity.css'; // Import the custom CSS file

// function CrossSellOpportunity() {
//   const [companyId, setCompanyId] = useState('');
//   const [crossSellData, setCrossSellData] = useState(null);
//   const [error, setError] = useState('');
//   const [isCentered, setIsCentered] = useState(true); // State to manage centering

//   // Handle the recommendation request
//   const handleGetRecommendations = async () => {
//     try {
//       const data = await getCrossSellRecommendations({ company_name: companyId });
//       setCrossSellData(data);
//       setError(''); // Clear any previous errors
//       setIsCentered(false); // Set to not centered when clicking
//     } catch (error) {
//       console.error('Error fetching recommendations:', error);
//       setError('Failed to get recommendations. Please try again.');
//     }
//   };

//   // Parse plot data from JSON
//   const plotData = crossSellData?.plot ? JSON.parse(crossSellData.plot) : { data: [], layout: {} };

//   return (
//     <div className={`container ${isCentered ? 'centered' : ''}`}>
//       <div className="header">
//         <h1 className="text-2xl font-bold mb-4">Cross-Sell Predictions</h1>
//       </div>
//       <div className="select-button-container mb-4">
//         <select
//           onChange={(e) => setCompanyId(e.target.value)}
//           value={companyId}
//           className="p-2 border border-gray-300 rounded"
//         >
//           <option value="">Select Company</option>
//           <option value="Nippon Paints">Nippon Paints</option>
//           <option value="Lockheed Martin">Lockheed Martin</option>
//           <option value="Verizon">Verizon</option>
//         </select>
//         <button
//           onClick={handleGetRecommendations}
//           className="p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//         >
//           Get Recommendations
//         </button>
//       </div>

//       {error && <div className="text-red-500 mb-4">{error}</div>}

//       {crossSellData && (
//         <div>
//           <h2 className="text-xl font-semibold mb-4">Total Opportunity: {crossSellData.total_opportunity}</h2>
//           {plotData.data.length > 0 && (
//             <div className="plot-container mb-4">
//               <Plot
//                 data={plotData.data}
//                 layout={plotData.layout}
//                 config={{ displayModeBar: true }} // Optional: display mode bar for interactions
//               />
//             </div>
//           )}
//           <h3 className="text-lg font-semibold mb-2">Cross-Sell Oppurtunity</h3>
//           <div className="table-container">
//             <table>
//               <thead>
//                 <tr>
//                   <th>Product Family</th>
//                   <th>Product Family Description</th>
//                   <th>Avg Base Price</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {crossSellData.cross_sell_products && crossSellData.cross_sell_products.map((product, idx) => (
//                   <tr key={idx}>
//                     <td>{product["Product Family"] || 'No Product Family'}</td>
//                     <td>{product["Product Family Description"] || 'No Description'}</td>
//                     <td>${product["Avg Base Price"].toLocaleString('en-US') }</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default CrossSellOpportunity;


import React, { useState } from 'react';
import Plot from 'react-plotly.js';
import { getCrossSellRecommendations } from '../api';
import './CrossSellOpportunity.css'; // Updated CSS for ultra-polished look

function CrossSellOpportunity() {
  const [companyId, setCompanyId] = useState('');
  const [crossSellData, setCrossSellData] = useState(null);
  const [error, setError] = useState('');
  const [isCentered, setIsCentered] = useState(true);

  const handleGetRecommendations = async () => {
    try {
      const data = await getCrossSellRecommendations({ company_name: companyId });
      setCrossSellData(data);
      setError('');
      setIsCentered(false);
    } catch (error) {
      console.error('Error fetching recommendations:', error);
      setError('Failed to get recommendations. Please try again.');
    }
  };

  const plotData = crossSellData?.plot ? JSON.parse(crossSellData.plot) : { data: [], layout: {} };

  return (
    <div className="container">
      <header className="header">
        <h1 className="main-title">Cross-Sell Opportunities</h1>
        <p className="sub-text">Discover key product recommendations for business growth.</p>
      </header>

      <section className="form-section">
        <select
          onChange={(e) => setCompanyId(e.target.value)}
          value={companyId}
          className="dropdown"
        >
          <option value="">Select Company</option>
          <option value="Verizon">Verizon</option>
          {/* <option value="Nippon Paints">Nippon Paints</option> */}
          <option value="Lockheed Martin">Lockheed Martin</option>
          {/* <option value="Verizon">Verizon</option> */}
          <option value="Vandalia Health">Vandalia Health</option>
        </select>
        <button onClick={handleGetRecommendations} className="button">
          Get Recommendations
        </button>
      </section>

      {error && <div className="error-message">{error}</div>}

      {crossSellData && (
        <div className="results-container">
          <div className="card plot-card">
            <h2 className="card-title">Total Opportunity: {crossSellData.total_opportunity}</h2>
            {plotData.data.length > 0 && (
              <div className="plot-wrapper">
                <Plot
                  data={plotData.data}
                  layout={plotData.layout}
                  config={{ displayModeBar: false }}
                />
              </div>
            )}
          </div>

          <div className="card table-card">
            <h3 className="section-title">Cross-Sell Recommendations</h3>
            <div className="table-wrapper">
              <table className="styled-table">
                <thead>
                  <tr>
                    <th>Product Family</th>
                    
                    <th>Avg Base Price</th>
                  </tr>
                </thead>
                <tbody>
                  {crossSellData.cross_sell_products &&
                    crossSellData.cross_sell_products.map((product, idx) => (
                      <tr key={idx}>
                        <td>{product["Product Family"] || 'N/A'}</td>
                        
                        <td>${product["Avg Base Price"].toLocaleString('en-US')}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CrossSellOpportunity;
